export abstract class BaseNetworkLog {
  public id: string;

  constructor(id: string) {
    this.id = id;
  }
}
